<div class="d-flex flex-column px-4 pt-3">


  <div *ngIf="!paymentConditions || paymentConditions.length === 0 || !allItems || allItems.length === 0 || paymentRegister"
       class="loading-container d-flex flex-column align-items-center justify-content-center py-5">


    <div class="logo-loading mb-4">
      <img [src]="agencyImagen"
           alt="Logo"
           class="loading-logo animate__animated animate__pulse animate__infinite">
    </div>


    <div class="text-center animate__animated animate__fadeIn">
      <h4 *ngIf="type === 'payment'" class="text-muted mb-3">{{paymentRegister ? 'Estamos registrando su pago, gracias por esperar...' : 'Estamos preparando todo para registrar su pago...'}}</h4>
       <h4 *ngIf="type === 'request-billed'" class="text-muted mb-3">{{paymentRegister ? 'Estamos registrando su solicitud de facturación, gracias por esperar...' : 'Estamos preparando todo para registrar su solicitud de facturación...'}}</h4>

      <div [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1}" class="spinner-border" role="status">
      </div>
    </div>
  </div>


<div *ngIf="paymentConditions && paymentConditions.length > 0 && allItems && allItems.length > 0 && !paymentRegister"  class="d-flex flex-column w-100">

  <div class="d-flex justify-content-between mx-auto mb-4" style="width: 97%">
         <h1 *ngIf="type === 'payment'" class="title mb-0 mt-2" style="line-height: 1 !important; color: black !important;">
         REGISTRO DE PAGO
         </h1>

         <h1 *ngIf="type === 'request-billed'" class="title mb-0 mt-2" style="line-height: 1 !important; color: black !important;">
         SOLICITUD DE FACTURACIÓN
         </h1>

     <button type="button" class="close btn-close" title="Close" (click)="closeTop()">
       <span aria-hidden="true" style="font-size: 50px; font-weight: 100;">&times;</span>
     </button>

 </div>
    <!-- step by step numeros -->
   <div class=" d-flex py-4 container-step align-items-center mx-auto justify-content-center" style="width: 99%">
     <!-- <div class="line-step"></div> -->
     <div class=" d-flex justify-content-center position-relative"
           style="text-align: center; flex-direction: column; width: 8.85%">
       <div class="circle font-poppins d-flex justify-content-center align-items-center "
       [ngStyle]="{'background-color': step === 1 ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"
       style="margin: 0 auto;">
         01
       </div>
       <div>
         <p style="font-size: 14px;">SELECCIONAR</p>
       </div>
     </div>
     <div [ngStyle]="{'background-color': step === 2 ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : getClientsSettingAppBooking?.clients_setting_global?.color_main_2}" style="margin-bottom: 1.9em; height: 2px; width: 16.85%"></div>
     <div class=" d-flex justify-content-center position-relative"
     style="text-align: center; flex-direction: column;width: 8.85%">
       <div class="circle font-poppins d-flex justify-content-center align-items-center"
        [ngStyle]="{'background-color': step === 2 ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : getClientsSettingAppBooking?.clients_setting_global?.color_main_2}" style="margin: 0 auto;">
         02
       </div>
       <div>
         <p style="font-size: 14px;">CONFIRMAR</p>
       </div>
     </div>
          <div [ngStyle]="{'background-color': step === 3 ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : getClientsSettingAppBooking?.clients_setting_global?.color_main_2}" style="margin-bottom: 1.9em; height: 2px; width: 16.85%"></div>
     <div class=" d-flex justify-content-center position-relative"
     style="text-align: center; flex-direction: column; width: 8.85%">
       <div class="circle font-poppins d-flex justify-content-center align-items-center"
        [ngStyle]="{'background-color': step === 3 ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : getClientsSettingAppBooking?.clients_setting_global?.color_main_2}" style="margin: 0 auto;">
         03
       </div>
       <div>
         <p *ngIf="type === 'payment'" style="font-size: 14px;">PAGAR</p>
         <p *ngIf="type === 'request-billed'" style="font-size: 14px;">FORMULARIO</p>
       </div>
     </div>
           <div [ngStyle]="{'background-color': step === 4 ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : getClientsSettingAppBooking?.clients_setting_global?.color_main_2}" style="margin-bottom: 1.9em; height: 2px; width: 16.85%"></div>
     <div class="d-flex justify-content-center position-relative"
     style="text-align: center; flex-direction: column;width: 8.85%">
       <div class="circle font-poppins d-flex justify-content-center align-items-center"
       [ngStyle]="{'background-color': step === 4 ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : getClientsSettingAppBooking?.clients_setting_global?.color_main_2}" style="margin: 0 auto;">
         04
       </div>
       <div>
         <p *ngIf="type === 'payment'" style="font-size: 14px;">DOCUMENTACION</p>
         <p *ngIf="type === 'request-billed'" style="font-size: 14px;">SOLICITUD</p>
       </div>
     </div>

   </div>

   <div class=" px-3 row mt-3 mb-3">

     <ng-container *ngIf="step == 1">
       <usb-select-items class="col-12 px-0"
           [items]="allItems"
           [currencyItinerary]="currencyItinerary"
           [currencies]="currencies"
           [currencyAgency]="currencyAgency"
           [getClientsSettingAppBooking]="getClientsSettingAppBooking"
           (selectItem)="handleItem($event)"
       ></usb-select-items>
     </ng-container>

     <ng-container *ngIf="step == 2">
       <usb-confirm-items class="col-12 px-0"
                           [items]="selectedItems"
                           [currencyItinerary]="currencyItinerary"
                           [clientSetting]="getClientsSettingAppBooking"
                           [currencies]="currencies"
                           [currencyAgency]="currencyAgency"></usb-confirm-items>
     </ng-container>

     <ng-container *ngIf="type === 'payment' && step == 3">
       <usb-payment-items class="col-12 px-0"
         [items]="selectedItems"
         [itineraryItems]="itinerary.items"
         [totalPrice]="totalPrice"
         [paymentMethodsArr]="paymentMethods"
         [currencyItinerary]="currencyItinerary"
         [creditCardPending]="creditCardPending"
         [creditCardPayPartial]="creditCardPayPartial"
         [creditCardDataPending]="creditCardDataPending"
         [getClientsSettingAppBooking]="getClientsSettingAppBooking"
         [currencies]="currencies"
         [currencyAgency]="currencyAgency"
         [paymentConditions]="paymentConditions"
         [fee]="fee"
         (applyFeeEmitter)="applyFee($event)"
         (emitFeePayment)="feePayment($event)"
         (paymentCardWithApplyFeeEmitter)="alertToFee($event)"
         (currencyPaymentEmmiter)="currencyPaymentSelected($event)"
         (totalPriceEmit)="totalPricePayment($event)"
         (leaveTotal)="handleLeaveTotal($event)">
       </usb-payment-items>
     </ng-container>

     <ng-container *ngIf="type === 'request-billed' && step == 3">
       <usb-request-billed-form class="col-12 px-0"
         [items]="selectedItems"
         [itineraryItems]="itinerary.items"
         [currencyItinerary]="currencyItinerary"
         [currencies]="currencies"
         [currencyAgency]="currencyAgency"
         [idAbaco]="itinerary?.idAbaco"
         [itineraryPaxList]="itineraryPaxList"
         (payloadRequestBilling)="submitFormRequestBilling($event)"
         (leaveTotal)="handleLeaveTotal($event)">
       </usb-request-billed-form>
     </ng-container>

     <ng-container *ngIf="step == 4 && consultingPay">
       <usb-documentation class="col-12 px-0"
                         [items]="selectedItems"
                         [totalPrice]="totalPrice"
                         [paymentMethods]="paymentMethods"
                         [currencyAgency]="currencyAgency"
                         [currencies]="currencies"
                         [currencyPayment]="currencyPayment"
                         [currencyItinerary]="currencyPayment"
                         [amountBLickoinsItineraryPay]="amountBLickoinsItineraryPay"
                         [amountCardItineraryPay]="amountCardItineraryPay"
                         [amountDepositItineraryPay]="amountDepositItineraryPay"
                         [amountTransferItineraryPay]="amountTransferItineraryPay"

                          [amountTransferItineraryPayUSD]="amountTransferItineraryPayUSD"
                          [amountTransferItineraryPayAgency]="amountTransferItineraryPayAgency"

                         [itinerary]="itinerary"
                         [type]="type"
       >
       </usb-documentation>
     </ng-container>

     <ng-container *ngIf="step == 4 && type === 'request-billed'">
       <usb-documentation class="col-12 px-0"
                         [items]="selectedItems"
                         [totalPrice]="totalPrice"
                         [paymentMethods]="paymentMethods"
                         [currencyItinerary]="currencyItinerary"
                         [currencyPayment]="currencyPayment"
                         [itinerary]="itinerary"
                         [type]="type"
       >
       </usb-documentation>
     </ng-container>


   </div>

   <div *ngIf="getFeeMessage() && step < 4" class="d-flex justify-content-end align-items-center">
       <p class="mt-1" style="color: red; font-size: 24px;">*</p><p class="ml-1" style="font-family: 'Rubik', serif; font-size: 12px;font-weight: 400;line-height: 1; color: black"> Algunos productos tienen fee opcionales que podrán abonarse con tarjeta en el tercer paso si su agencia tiene activo este método de pago</p>
   </div>

     <div *ngIf="type === 'payment'" class="d-flex pt-4 justify-content-end mr-4.5" style="height: 75px; gap: 1em;">
       <div class="d-flex flex-column align-items-end justify-content-center">
         <p class="mb-0" style="font-family: 'Rubik', serif; font-size: 20px;font-weight: 500;line-height: 1; color: #666666">MONTO TRANSACCIÓN</p>
         <div class="d-flex">
           <p *ngIf="creditCardPayPartial" class="mb-0" style="font-family: 'Rubik', serif; font-size: 22px;font-weight: 700;line-height: 1; color: black">
            <!-- {{currencyItinerary}} {{partialLeftCreditCard | number:'1.2-2'}} -->
            TOTAL  {{currencyPayment ? currencyPayment : currencyAgency?.code}} {{ partialLeftCreditCard | number: '1.2-2'}}
           </p>
           <p *ngIf="creditCardDataPending.length > 0 && !creditCardPayPartial" class="mb-0" style="font-family: 'Rubik', serif; font-size: 22px;font-weight: 700;line-height: 1; color: black">
             <!-- {{currencyItinerary}} {{amountFilterNull | number:'1.2-2'}} -->
             TOTAL {{currencyPayment ? currencyPayment : currencyAgency?.code}} {{amountFilterNull | number: '1.2-2'}}
           </p>
           <p *ngIf="creditCardDataPending.length === 0" class="mb-0" style="font-family: 'Rubik', serif; font-size: 22px;font-weight: 700;line-height: 1; color: black">
          <!-- {{currencyItinerary}} {{ totalPrice | number:'1.2-2'}} -->
             TOTAL {{currencyPayment ? currencyPayment : currencyAgency?.code}} {{(totalPaymentPrice > 0 ? totalPaymentPrice : totalPrice) | number: '1.2-2'}}
           </p>


           <div *ngIf="step < 4" class="info-tool d-flex flex-column position-relative">
                  <i class="fa fa-info-circle"
                   aria-hidden="true"
                   style="font-size: 13px;"
                   [ngStyle]="{'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"></i>
                 <span class="tooltip-info shadow-md">
                   <table class="table-info-tool">
                      <tr style="border-bottom: 1px solid #ececec;">
                       <th style="text-align: center">
                         <p>Cambio</p>
                       </th>
                     </tr>
                     <ng-container *ngFor="let currency of currencies">
                       <tr *ngIf="currency.code !== (currencyPayment ? currencyPayment : currencyAgency?.code)">
                         <td>
                           <p *ngIf="creditCardDataPending.length === 0" class="mb-2">
                            <span style="color: black">{{ currency.code }}</span>
                            <span style="font-weight: 600; color: black;">&nbsp; {{
                               (totalPaymentPrice > 0 ? totalPaymentPrice : totalPrice) | currencyConverter: (currencyPayment ? currencyPayment : currencyAgency?.code): currency.code: currencies   | number: '1.2-2'}}
                             </span>
                           </p>
                           <p *ngIf="creditCardDataPending.length > 0 && !creditCardPayPartial" class="mb-2">
                           <span style="color: black">{{ currency.code }}</span>
                            <span style="font-weight: 600; color: black;">&nbsp; {{
                               amountFilterNull | currencyConverter: (currencyPayment ? currencyPayment : currencyAgency?.code): currency.code: currencies  | number: '1.2-2'}}
                             </span>
                           </p>
                           <p *ngIf="creditCardPayPartial" class="mb-2">
                            <span style="color: black">{{ currency.code }}</span>
                             <span style="font-weight: 600; color: black;">&nbsp;{{
                               partialLeftCreditCard | currencyConverter: (currencyPayment ? currencyPayment : currencyAgency?.code): currency.code: currencies  | number: '1.2-2'}}
                             </span>
                           </p>
                         </td>
                       </tr>
                     </ng-container>
                   </table>
                 </span>
               </div>
             </div>
           </div>

                  <button
                         type="button"
                         class="btn btn-continue"
                         (click)="goBack()"
                         *ngIf="step > 1 && step < 4 && creditCardDataPending.length === 0"
                         [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"
                         [disabled]="paymentSync"
                         >Volver
                 </button>
                  <button
                         type="button"
                         class="btn btn-continue"
                        (click)="next()"
                         *ngIf="step < 4 && type === 'payment'"
                         [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
                         [disabled]="verifyNext() || paymentSync"
                         >Continuar
                 </button>
                  <button
                         *ngIf="step == 4"
                         type="button"
                         class="btn btn-continue"
                          [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"
                         (click)="close()"
                         >Cerrar
                 </button>
     </div>

     <div  *ngIf="type === 'request-billed'" class="d-flex pt-4 justify-content-end mr-4.5" style="height: 75px; gap: 1em;">
       <button
                         type="button"
                         class="btn btn-continue"
                         (click)="next()"
                         *ngIf="step < 4"
                         [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_3}"
                         [disabled]="verifyNext()"
                         >Continuar
                 </button>
                  <button
                         *ngIf="step == 4"
                         type="button"
                         class="btn btn-continue"
                          [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}"
                         (click)="close()"
                         >Cerrar
                 </button>
     </div>

</div>
</div>
